import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class SystemDataService {
    baseUrl: string = 'SystemData.svc';    
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    multiuserhandler(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/multiuserhandler", dataToBePost);        
    }
    maintainancecheck() {        
        return this._ajaxService.GET(this.baseUrl + "/maintainancecheck");        
    }
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/systemdata.service.ts